// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;

// Storage keys
export const STORAGE_KEYS = {
	AUTH_TOKEN: 'bbp_auth_token',
	USER_DATA: 'bbp_user_data',
	REMEMBER_ME: 'bbp_remember_me',
	LOGIN_TIMESTAMP: 'bbp_login_timestamp',
} as const;

// Session expiration duration (1 hour in milliseconds)
export const SESSION_EXPIRATION_MS = 60 * 60 * 1000; // 1 hour

// API endpoints
export const API_ENDPOINTS = {
	AUTH: {
		SIGNIN: '/user/signin',
		CHANGE_PASSWORD: '/user/change-password',
	},
	OTP: {
		SEND: '/otp/send',
		VERIFY: '/otp/verify',
		RESEND: '/otp/resend',
	},
	DASHBOARD: '/dashboard',
	PROVIDERS: {
		LIST: '/provider',
		CREATE: '/provider',
		DETAIL: (id: number) => `/provider/${id}`,
		UPDATE: (id: number) => `/provider/${id}`,
	},
	PROVIDER: {
		ME: '/provider/me',
		DASHBOARD: '/provider/dashboard',
		PAYMENT_SETUP: (id: number) => `/provider/${id}/payment/bank/setup`,
		PAYMENT_CONFIRM: (id: number) => `/provider/${id}/payment/bank/confirm`,
		PAYMENT_VERIFY: (id: number) => `/provider/${id}/payment/bank/verify`,
		CANCEL_SUBSCRIPTION: (id: number) => `/provider/${id}/payment/subscription`,
		RESUME_SUBSCRIPTION: (id: number) => `/provider/${id}/payment/subscription/resume`,
		TCR_APPROVALS: '/provider/tcr-approvals',
		TCR_APPROVE: (id: number) => `/provider/tcr/${id}/approve`,
		TCR_REJECT: (id: number) => `/provider/tcr/${id}/reject`,
		TCR_PHOTOS: (id: number) => `/provider/tcr/${id}/photos`,
	},
	LOCATION: '/location',
	SERVICE: {
		BASE: '/service',
		MY_SERVICES: '/service/my-services',
		BULK_UPLOAD: '/service/bulk-upload',
		BULK_UPLOAD_TEMPLATE: '/service/bulk-upload/template',
		BULK_UPLOAD_STATUS: (id: number) => `/service/bulk-upload/${id}/status`,
	},
	SERVICE_TASK: '/service-task',
	SERVICE_TASK_AVAILABLE: '/service-task/available-services',
	PROVIDER_TASK: {
		BASE: '/provider-task',
		DETAIL: (id: number) => `/provider-task/${id}`,
	},
	SERVICE_TASK_BULK_UPLOAD: '/service-task/bulk-upload',
	SERVICE_TASK_BULK_UPLOAD_TEMPLATE: '/service-task/bulk-upload/template',
	SERVICE_TASK_BULK_UPLOAD_STATUS: (id: number) => `/service-task/bulk-upload/${id}/status`,
	DEFAULT_SERVICE: '/default-service',
	STAFF: {
		BASE: '/staff',
		ME: '/staff/me',
		UPDATE_PERSONAL_INFO: '/staff/me/personal-info',
		UPDATE_SERVICES: '/staff/me/services',
		UPDATE_TASKS: '/staff/me/tasks',
		DASHBOARD: '/staff/dashboard',
		BOOKINGS: '/staff/bookings',
		BOOKING_DETAIL: (id: number) => `/staff/bookings/${id}`,
		TCR: '/staff/tcr',
		TCR_DETAIL: (id: number) => `/staff/tcr/${id}`,
		TCR_PHOTOS: (id: number) => `/staff/tcr/${id}/photos`,
		AGREEMENT: (type: string) => `/staff/me/agreement/${type}`,
		UPDATE_ADDRESS: '/staff/me/address',
		UPDATE_EMERGENCY_CONTACT: '/staff/me/emergency-contact',
		DETAIL: (id: number) => `/staff/${id}`,
		SEARCH: '/staff/search',
		BY_TASKS: '/staff/by-tasks',
		SERVICE_TASKS: '/staff/service-tasks',
	},
	CUSTOMER: {
		LOOKUP_BY_EMAIL: '/customer/lookup-by-email',
		LOOKUP_BY_PHONE: '/customer/lookup',
	},
	APPOINTMENT: {
		BASE: '/appointment',
		DASHBOARD_LIST: '/appointment/dashboard',
		UPDATE_STATUS: (id: number, status: string) => `/appointment/${id}/status/${status}`,
		RESCHEDULE: (id: number) => `/appointment/${id}/reschedule`,
		SCHEDULE: (id: number) => `/appointment/${id}/schedule`,
		SERVICE_DETAILS: (id: number) => `/appointment/${id}/service-details`,
	},
	INTEGRATION: {
		BASE: '/integration',
		DETAIL: (id: number) => `/integration/${id}`,
	},
	INVOICE: {
		LIST: '/invoice/list',
		SEND: '/invoice/send',
	},
} as const;
